import {ThemeType} from '../../../theme';
import {BaseLayoutProps, LayoutProps} from '../types';
import {getExcitedPropVariants} from './getExcitedPropVariants';
import {
  mapPaddingToBaseProperties,
  mapFocusBorderToBaseProperties,
  getDirectThemeToBaseProperties,
  mapColorToBase,
} from '../../themed/functions';
import {withCaching} from '../../../utils';

const mapToBasePropertiesInternal = (
  theme: ThemeType,
  {focusBorder, ...props}: LayoutProps,
): BaseLayoutProps => {
  const {onPress, backgroundColor, opacity, spacing, hideWhen, hover} = props;

  return {
    ...mapPaddingToBaseProperties(theme, props),
    ...mapFocusBorderToBaseProperties(theme, focusBorder, props),
    ...getDirectThemeToBaseProperties(props),
    ...(backgroundColor
      ? {backgroundColor: mapColorToBase(theme, backgroundColor)}
      : undefined),
    ...(opacity ? {opacity} : undefined),
    onPress,

    // Spacing
    spacing: spacing ? theme.spacing[spacing] : undefined,

    hideWhen: hideWhen
      ? (hideWhen instanceof Array ? hideWhen : [hideWhen]).map(p =>
          typeof p === 'string' ? theme.devices[p] : p,
        )
      : undefined,
    hover: hover ? getExcitedPropVariants(theme, {backgroundColor}) : undefined,
  };
};

export const mapToBaseProperties = withCaching(mapToBasePropertiesInternal);
